// FieldLabel component extracted from TaskForm
import { Typography } from '@mui/material';

/**
 * @param {{ children: import('react').ReactNode, htmlFor?: string }} props
 */
function FieldLabel({ children, htmlFor }) {
  return (
    <Typography
      component="label"
      htmlFor={htmlFor}
      variant="caption"
      sx={{
        display: 'block',
        color: 'text.subtle',
        fontWeight: 700,
        mb: 0.5,
      }}
    >
      {children}
    </Typography>
  );
}

export default FieldLabel;
